<script lang="ts" setup>
import GreenChecks from "@src/assets/vectors/green_checks.svg";
import GrayChecks from "@src/assets/vectors/gray_checks.svg";

const props = defineProps<{
    state: string;
}>();
</script>

<template>
    <img
        v-if="props.state === '2'"
        :src="GrayChecks"
        class="w-[.875rem] h-[.875rem]"
    />
    <img
        v-else-if="props.state === '4' || props.state === '3'"
        :src="GreenChecks"
        class="w-[.875rem] h-[.875rem]"
    />
</template>
